import { render, staticRenderFns } from "./uploadSealedInsure.vue?vue&type=template&id=70558e76&scoped=true&"
import script from "./uploadSealedInsure.vue?vue&type=script&lang=js&"
export * from "./uploadSealedInsure.vue?vue&type=script&lang=js&"
import style0 from "./uploadSealedInsure.vue?vue&type=style&index=0&id=70558e76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70558e76",
  null
  
)

export default component.exports